import { render } from "./MenuCollapse.vue?vue&type=template&id=c8b5b1da"
import script from "./MenuCollapse.vue?vue&type=script&lang=js"
export * from "./MenuCollapse.vue?vue&type=script&lang=js"

import exportComponent from "/home/runcloud1user/webapps/ismail-khayat-vue/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.26_vue@3.5.26_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__